// Google Maps URL parser — extracts { lat, lng } from various share/embed URL formats.
// Handles the common share patterns:
//   • https://www.google.com/maps/place/Foo/@-6.2434,106.8006,17z/...
//   • https://www.google.com/maps/@-6.2434,106.8006,15z
//   • https://maps.google.com/?q=-6.2434,106.8006
//   • https://www.google.com/maps?q=-6.2434,106.8006
//   • https://goo.gl/maps/XXXX  and  https://maps.app.goo.gl/XXXX  (SHORT LINKS — cannot resolve
//     client-side because of CORS; we still try to detect the pattern and prompt the user to open the
//     link first and paste the full URL from the address bar).
//   • Raw "lat,lng" strings ("-6.2434, 106.8006")
//
// Returns { lat: number, lng: number } on success, or null on failure.

export function parseGmapsUrl(input) {
  if (!input) return null;
  const s = String(input).trim();
  if (!s) return null;

  // Raw "lat, lng" (with optional spaces)
  const raw = s.match(/^\s*(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)\s*$/);
  if (raw) {
    const lat = Number(raw[1]);
    const lng = Number(raw[2]);
    if (isValidLatLng(lat, lng)) return { lat, lng };
  }

  // "@lat,lng" pattern found in place URLs
  const at = s.match(/@(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/);
  if (at) {
    const lat = Number(at[1]);
    const lng = Number(at[2]);
    if (isValidLatLng(lat, lng)) return { lat, lng };
  }

  // "!3dLAT!4dLNG" pattern in place data blob
  const bang = s.match(/!3d(-?\d{1,3}\.\d+)!4d(-?\d{1,3}\.\d+)/);
  if (bang) {
    const lat = Number(bang[1]);
    const lng = Number(bang[2]);
    if (isValidLatLng(lat, lng)) return { lat, lng };
  }

  // "?q=lat,lng" or "&q=lat,lng"
  const q = s.match(/[?&]q=(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/);
  if (q) {
    const lat = Number(q[1]);
    const lng = Number(q[2]);
    if (isValidLatLng(lat, lng)) return { lat, lng };
  }

  // "?ll=lat,lng"
  const ll = s.match(/[?&]ll=(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/);
  if (ll) {
    const lat = Number(ll[1]);
    const lng = Number(ll[2]);
    if (isValidLatLng(lat, lng)) return { lat, lng };
  }

  return null;
}

export function isShortGmapsLink(input) {
  if (!input) return false;
  return /https?:\/\/(?:goo\.gl\/maps|maps\.app\.goo\.gl)\//i.test(String(input));
}

function isValidLatLng(lat, lng) {
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180;
}

// Build an "open in Google Maps" URL from coordinates (used for the preview button).
export function gmapsUrlFromCoords(lat, lng) {
  if (!isValidLatLng(Number(lat), Number(lng))) return "";
  return `https://www.google.com/maps?q=${lat},${lng}`;
}
